<template>
  <thead>
    <tr>
      <th class="primeira-coluna" rowspan="2"></th>
      <th
        v-for="(t, i) in Object.keys(fornecedores)"
        :key="i"
        :colspan="Object.values(fornecedores[t]).length"
      >
        {{ t == 'Preco de compra' ? 'Preço de compra' : t }}
      </th>
    </tr>

    <tr>
      <template v-for="n in Object.keys(fornecedores)">
        <th
          v-for="(f, i) in fornecedores[n]"
          :key="`${n}-${i}`"
          class="font-12"
        >
          {{ f || '' }}
        </th>
      </template>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'THeaders',
  props: {
    fornecedores: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
th {
  height: 35px !important;
  border: 1px solid #797878 !important;
}
th {
  height: 35px !important;
  border: 1px solid #797878 !important;
}
.primeira-coluna {
  overflow: hidden;
  white-space: nowrap;
  min-width: 250px !important;
}
</style>
